import React from "react";
import { InputGroup } from "@blueprintjs/core";
import Flexbox from "flexbox-react";

const getInitials = (name = "") =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

const EmployeeSidebar = ({
  employees,
  search,
  selectedEmployee,
  onSearchChange,
  onSelectEmployee
}) => {
  return (
    <div className="onboarding-sidebar">
      <InputGroup
        leftIcon="search"
        placeholder="Search employees..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        className="sidebar-search"
      />
      <div className="employee-list-scroll">
      {employees.length === 0 ? (
        <div className="no-data">No employees found.</div>
      ) : employees.map((emp) => (
        <div
          key={emp.id}
          className={`employee-item ${
            selectedEmployee?.id === emp.id ? "active" : ""
          }`}
          onClick={() => onSelectEmployee(emp)}
        >
          <div className="employee-avatar-small">
            {getInitials(emp.name)}
          </div>

          <div className="employee-details">
            <div className="employee-name">{emp.name}</div>
            <div className="employee-role">{emp.role}</div>
          </div>

          <div className="progress-badge">{emp.tasks_percent_complete}%</div>
        </div>
      ))}
      </div>

      </div>
  );
};

export default EmployeeSidebar;
